import React from "react";
import PricingSection from "../components/PricingSection";
import { Card } from "../components/ui/card";
import { ShieldCheck, RotateCcw, CreditCard } from "lucide-react";

export default function Pricing() {
  return (
    <div data-testid="pricing-page">
      <PricingSection
        eyebrow="Plans & pricing"
        heading={
          <>
            Attract, assess, nurture, convert. <span className="italic text-accent">All from one platform.</span>
          </>
        }
        subheading="Everything you need to attract, assess, nurture, convert and grow consulting clients from one platform. Monthly or lifetime — change or cancel any time."
      />

      <section className="max-w-5xl mx-auto px-6 lg:px-10 pb-20">
        <div className="grid md:grid-cols-3 gap-5">
          <Card className="card-elevated p-6">
            <CreditCard className="w-5 h-5 text-accent" />
            <div className="font-sans-ui font-semibold mt-3">Billed by Paddle</div>
            <p className="text-sm text-muted-foreground mt-2 leading-relaxed">
              All purchases are processed by Paddle, our merchant of record. Local taxes are handled for you.
            </p>
          </Card>
          <Card className="card-elevated p-6">
            <RotateCcw className="w-5 h-5 text-accent" />
            <div className="font-sans-ui font-semibold mt-3">14-day money back</div>
            <p className="text-sm text-muted-foreground mt-2 leading-relaxed">
              Not the right fit? Email <a href="mailto:contact@bizpulseai.net" className="text-accent">contact@bizpulseai.net</a> within
              14 days of your first invoice for a full refund.
            </p>
          </Card>
          <Card className="card-elevated p-6">
            <ShieldCheck className="w-5 h-5 text-accent" />
            <div className="font-sans-ui font-semibold mt-3">Cancel anytime</div>
            <p className="text-sm text-muted-foreground mt-2 leading-relaxed">
              Monthly plans can be cancelled from your dashboard in one click. Lifetime plans are a one-time payment.
            </p>
          </Card>
        </div>
      </section>
    </div>
  );
}
